import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import Header from "../Header";
import useLocalStorage from "../../hooks/useLocalStorage";
import { ModalContext } from "../../context";

import settings from "../../config";

const ProductionAssets = () => {
  const [productionAssets, seProductionAssets] = useState([]);
  const [admin] = useLocalStorage("admin");
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}production-assets/`);

      if (response.data.statusCode === 200) {
        seProductionAssets(response.data.data);
      }
    })();
  }, []);

  const deleteBillCategory = async (productionAssetId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}production-assets/delete`,
          {
            productionAssetId,
          },
        );

        if (response.data.statusCode === 200) {
          seProductionAssets(
            productionAssets.filter(
              (asset) => productionAssetId !== asset.productionAssetId,
            ),
          );
        }
      },
    });
  };

  return (
    <div className="w-full" dir="rtl">
      <Header
        title="متطلبات الانتاج"
        text="اضافه متطلب انتاج"
        link="/production-asset/form"
      />
      <table className="w-full table-auto text-right ">
        <thead>
          <tr>
            <th className="p-4">مسلسل</th>
            <th className="p-4">المتطلب انتاج</th>
            <th className="text-center w-24 p-4">تركيب</th>
            {admin.canEdit === 1 && (
              <th className="text-center w-24 p-4">تعديل</th>
            )}
            {admin.canDelete === 1 && (
              <th className="text-center w-24 p-4">حذف</th>
            )}
          </tr>
        </thead>
        <tbody>
          {productionAssets.map((productionAsset) => {
            return (
              <tr
                key={productionAsset.productionAssetId}
                className="odd:bg-secondaryBg"
              >
                <td className="p-4">{productionAsset.productionAssetId}</td>
                <td className="p-4">{productionAsset.productionAssetName}</td>
                <td className="text-center p-4">
                  <div className="flex flex-col items-center w-full cursor-pointer">
                    <div className="font-bold rounded-full">
                      <Link
                        to={`/production-asset/variants/${productionAsset.productionAssetId}`}
                      >
                        👕
                      </Link>
                    </div>
                  </div>
                </td>
                {admin.canEdit === 1 && (
                  <td className="text-center p-4">
                    <Link
                      to={`/production-asset/form/${productionAsset.productionAssetId}`}
                      className="flex flex-col items-center w-full cursor-pointer"
                    >
                      ✏
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className="text-center p-4">
                    <div
                      className="flex flex-col items-center w-full cursor-pointer"
                      onClick={() =>
                        deleteBillCategory(productionAsset.productionAssetId)
                      }
                    >
                      ❌
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProductionAssets;
